import styled from 'styled-components';
import { colors } from '../../../styles/colors';

export const Styles = styled.div`
  .about-us {
    padding: 78px 0 85px;

    .about-image {
      max-width: 550px;
      aspect-ratio: 550 / 440;
      position: relative;

      img {
        width: 100%;
        border-radius: 5px;
      }

      @media (min-width: 991px) {
        margin-right: 15px !important;
      }
    }

    .about-content {
      h2,
      h3,
      h4,
      h5 {
        color: ${colors.black1};
        line-height: 35px;
        font-weight: 600;
        margin-bottom: 25px;

        @media (max-width: 575px) {
          margin-bottom: 15px;
          font-size: 20px;
        }

        margin-top: 30px;
      }

      a {
        font-size: 15px;
      }

      div.about-para {
        p {
          font-size: 15px !important;
          color: ${colors.text3};
          line-height: 25px;

          /* &:not(last-child) { */
          /* outline: 2px solid blue; */
          margin-bottom: 15px;
          /* } */

          span {
            display: block;
            margin-top: 20px;
          }

          @media (max-width: 575px) {
            margin-bottom: 20px;
          }
        }
        ul {
          li {
            font-size: 15px;
            color: ${colors.text3};
            margin-bottom: 10px;
            line-height: 25px;
            display: flex;
            align-items: center;
            justify-content: left;
            width: 100%;
            i {
              color: ${colors.blue2};
              border: 1px solid ${colors.border3};
              border: none;
              margin-right: 10px;
            }

            &:last-child {
              margin-bottom: 0;
            }

            @media (max-width: 575px) {
              font-size: 14px;
            }
          }
        }
      }

      .counter-box {
        h3 {
          margin-bottom: 10px;

          span {
            font-weight: 600;
          }

          i {
            font-size: 20px;
            vertical-align: middle;
          }
        }

        p {
          font-size: 14px;
          color: ${colors.text3};
          font-weight: 500;
        }

        @media (max-width: 575px) {
          display: none;
        }
      }

      .counter-box.box1 {
        h3 {
          color: ${colors.red};
        }
      }

      .counter-box.box2 {
        h3 {
          color: ${colors.purple};
        }
      }

      .counter-box.box3 {
        h3 {
          color: ${colors.blue};
        }
      }

      a.readmore-btn {
        font-size: 14px;
        color: #fff;
        background: ${colors.grBg};
        display: inline-block;
        width: 145px;
        height: 40px;
        text-align: center;
        padding: 11px;
        border-radius: 5px;
        margin-top: 40px;

        &:hover {
          background: ${colors.grBg2};
        }

        @media (max-width: 575px) {
          margin-top: 0;
        }
      }
    }

    @media (max-width: 767px) {
      padding: 30px 0 40px;
    }
  }
`;
